module.exports = {
	"library.navbar.sign_up": "Een account aanmaken",
	"library.navbar.sign_in": "Aanmelden",
	"library.navbar.sign_out": "Afmelden",
	"library.navbar.help": "Help",
	"library.navbar.search_for_events": "Zoek events",
	"library.navbar.enter_location": "Geef de omgeving in",
	"library.navbar.find_events": "Zoek events",
	"library.navbar.create_event": "Creëer event",
	"library.navbar.host_events": "Organiseer events",
	"library.navbar.dashboard": "Dashboard",
	"library.navbar.my_events": "Door u georganiseerde events",
	"library.navbar.my_tickets": "My Tickets",
	"library.navbar.admin_panel": "Configuratiescherm",
	"library.navbar.profile": "Profiel",
	"library.navbar.messages": "Berichten",
	"library.navbar.settings": "Instellingen",
	"library.navbar.search_cities": "Steden doorzoeken",
	"library.navbar.help_center": "Helpdesk",
	"library.navbar.cant_find_tickets": "Where are my tickets?",
	"library.navbar.contact_organizer": "Contact the event organizer",
	"library.navbar.can_refund": "Can I get a refund?"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/navbar/translations/nl-be.json
// module id = 1515
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16